import { __assign } from "tslib";
import React from 'react';
import ddt from '@wix/da-ddt';
import Modal from '../Popup/Modal';
import ErrorBoundary from '../ErrorBoundary';
import { ModalType } from './redux/types';
import LoadableMediaManager from '../MediaPopup/MediaManager';
import { MediaSourceType } from '../MediaPopup/types';
import { LoadablePostPopup, LoadableWriterPopup, LoadableCommissionEditPopup, LoadablePollEditPopup, LoadableDealerPopup, LoadableAddToCollectionPopoverModal, LoadableDasModal, } from './LoadableModals';
import NonContentModals from './NonContentModals';
import LoadableTierPopup from '../Tier/TierPopup';
import LoadableDeviationSubmitPopup from '../DeviationSubmitPopup/LazyDeviationSubmitPopup';
import LoadableNftLinkPopup from '../Nft/NftLinkPopup';
/** Renders a single one of our many modals based on the contents of the `modal` prop */
var DaModal = function (_a) {
    var modal = _a.modal, children = _a.children, popModal = _a.popModal, currentUser = _a.currentUser, disableAriaHide = _a.disableAriaHide;
    if (!modal) {
        return null;
    }
    var modalType = modal.type;
    var _b = modal.options, options = _b === void 0 ? {} : _b;
    var params = options.params, _c = options.wrapInModal, wrapInModal = _c === void 0 ? true : _c, closeBtnClassName = options.closeBtnClassName;
    var content;
    if (children) {
        try {
            var renderedChildren = children(modalType, popModal, params);
            content = renderedChildren && (React.createElement(ErrorBoundary, { debugComponent: "DaModal" }, renderedChildren));
        }
        catch (e) {
            ddt.error('modals', 'Failed to render custom render function', e);
        }
    }
    if (!content) {
        switch (modalType) {
            case ModalType.STATUS_UPDATE:
                return (React.createElement(LoadablePostPopup, __assign({ onClose: popModal }, params, { mode: "status" })));
            case ModalType.JOURNAL:
                return (React.createElement(LoadablePostPopup, __assign({ onClose: popModal }, params, { mode: "journal" })));
            case ModalType.LITERATURE:
                return (React.createElement(LoadableWriterPopup, __assign({ onClose: popModal }, params, { type: "LITERATURE" })));
            case ModalType.CREATE_PREMIUM_FOLDER:
                var reloadPage = function (event) {
                    popModal();
                    event && event.preventDefault();
                    window.location.reload();
                };
                return (React.createElement(LoadableMediaManager, { initialMediaSource: MediaSourceType.GALLERY, withMediaSourceSelector: false, withNewGallectionPopupOpen: true, onDone: reloadPage, onClose: reloadPage }));
            case ModalType.COMMISSION:
                return React.createElement(LoadableCommissionEditPopup, __assign({ onClose: popModal }, params));
            case ModalType.POLL_EDIT:
                return React.createElement(LoadablePollEditPopup, __assign({}, params));
            case ModalType.TIER_EDIT:
                return React.createElement(LoadableTierPopup, __assign({ requestClose: popModal }, params));
            case ModalType.DEVIATION_SUBMIT:
                return (React.createElement(LoadableDeviationSubmitPopup, __assign({ requestClose: popModal }, params)));
            case ModalType.NFT_LINK:
                return React.createElement(LoadableNftLinkPopup, __assign({ requestClose: popModal }, params));
            case ModalType.COLLECTION_POPOVER:
                return React.createElement(LoadableAddToCollectionPopoverModal, __assign({}, params));
            case ModalType.DAS_MODAL:
                return React.createElement(LoadableDasModal, __assign({}, params));
            case ModalType.DEALER:
                return React.createElement(LoadableDealerPopup, __assign({}, params));
            default:
                content = (React.createElement(NonContentModals, __assign({}, { modalType: modalType, popModal: popModal, params: params, currentUser: currentUser })));
        }
    }
    return content && wrapInModal ? (React.createElement(Modal, { onRequestClose: popModal, withCloseButton: true, isOpen: true, width: "auto", height: "auto", disableAriaHide: disableAriaHide, closeBtnClassName: closeBtnClassName }, content)) : (content);
};
DaModal.displayName = 'DaModal';
export default DaModal;
//# sourceMappingURL=DaModal.js.map